// Machine Ticket Tiering: the tier ladder and what each rung unlocks.
// See docs/MACHINE_TICKET_TIERING_REQUIREMENTS.md.
//
// Lives here rather than in a component because the same ladder is read by the
// member-facing My Membership screen and by admin-side tier management, and two
// copies of it would drift.

export const TIER_NAMES = {
  0: 'Player',
  1: 'Glass access',
  2: 'Routine maintenance',
  3: 'Repair tech',
  4: 'Senior tech'
};

export const TIER_DESCRIPTIONS = {
  0: 'Can report issues and view machine status.',
  1: 'Can remove playfield glass to free stuck balls.',
  2: 'Routine maintenance, cleaning, logging - can work tickets.',
  3: 'Soldering, replacing switches, wires, coils.',
  4: 'Board-level repairs - top-tier diagnostic work.'
};

export const MAX_TIER = 4;

export const TIER_LADDER = [0, 1, 2, 3, 4];

// `min` is the lowest tier that unlocks the capability.
export const TIER_CAPABILITIES = [
  { min: 0, label: 'Report issues and view machine status' },
  { min: 0, label: 'View all open tickets and Known Issues' },
  { min: 1, label: 'Remove playfield glass' },
  { min: 1, label: 'Free stuck balls' },
  { min: 2, label: 'Perform general machine maintenance unsupervised' },
  { min: 2, label: 'Replace rubbers and bulbs' },
  { min: 3, label: 'Solder, replace switches and coils' },
  { min: 3, label: 'Escalate and resolve your tickets' },
  { min: 4, label: 'Board-level repairs' },
  { min: 4, label: 'Reassign tickets, manage Known Issues' }
];

// The sub-line under the capability checklist. States what comes next rather than
// what is already open, since the checklist itself already shows that.
export function capabilitySummary(tier) {
  if (tier >= MAX_TIER) {
    return 'Everything below is open to you.';
  }
  const nextTier = tier + 1;
  const unlockCount = TIER_CAPABILITIES.filter((c) => c.min === nextTier).length;
  return `Tier ${nextTier} unlocks the next ${unlockCount === 1 ? 'one' : unlockCount}.`;
}
